/* eslint-disable jsx-a11y/interactive-supports-focus, no-restricted-globals, jsx-a11y/click-events-have-key-events  */

import { ButtonBase, Popover } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { ArrowDropDown, Close } from '@material-ui/icons'
import cn from 'classnames'
import { Component } from 'react'

import Badge from '../Badge'
import PrimaryButton from '../Button/PrimaryButton/PrimaryButton'
import SecondaryButton from '../Button/SecondaryButton/SecondaryButton'
import LabelWrapper from '../LabelWrapper'
import TextOnlyButton from '../TextOnlyButton'
import { H2 } from '../Typography'

const styles = theme => ({
  labelWrapper: {
    '&.withBorder $button': {
      border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
      borderRadius: '4px',
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    },
    '&:not(.withBorder)': {
      '& $button': {
        paddingLeft: 0,
        background: 'transparent',
      },
    },
    '& .has-error $button': {
      borderColor: theme.status.errorColor,
      backgroundColor: theme.status.errorBG,
    },
    '& .disabled $button': {
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
      color: `var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`,
      '&:hover *': {
        cursor: 'not-allowed',
      },
    },
  },
  button: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    minWidth: '160px',
    height: '36px',
    fontSize: theme.typography.fontSizeSm,
    lineHeight: 1,
    color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
  },
  badge: {
    '& > div': {
      width: '34px',
      height: '34px',
    },
  },
  placeholder: {
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderRadius: '4px 0 0 4px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  valuePlace: {
    padding: '0 10px',
  },
  placeholderLabel: {
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    borderRadius: '0 4px 4px 0',
  },
  icon: {
    '& svg': {
      margin: '2px 4px 0 0',
      fontSize: '24px',
      color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  filterBtn: {
    '& svg': {
      fontSize: '20px',
    },
  },
  wrapper: {
    borderRadius: '4px',
    border: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)',
    '& .full-width-search .no-label': {
      padding: '0px !important',
    },
    '& .table-top': {
      position: 'sticky',
      top: '56px',
      backgroundColor: theme.colors.white,
      margin: 0,
      zIndex: 1,
    },
    '& .toolbar': {
      margin: '0 -16px',
      padding: '8px 16px 16px',
      position: 'sticky',
      top: '92px',
      backgroundColor: theme.colors.white,
      zIndex: 1,
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px',
    position: 'sticky',
    top: 0,
    backgroundColor: `var(--gameday-body-backgroundAlt, ${theme.body.backgroundAlt})`,
    zIndex: 1,
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '13px 16px',
    position: 'sticky',
    bottom: 0,
    backgroundColor: `var(--gameday-body-backgroundAlt, ${theme.body.backgroundAlt})`,
    borderTop: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    '& button:not(first-child)': {
      marginLeft: '8px',
    },
    '&:empty': {
      display: 'none',
    },
  },
  content: {
    padding: '0 16px 16px',
  },
  close: {
    borderRadius: '4px',
    margin: '-6px -6px 0 0',
    color: theme.colors.darkGrey,
  },
  modalWrapper: {
    '&.size-auto $wrapper': {
      width: 'auto',
    },
    '&.size-sm $wrapper': {
      width: '500px',
    },
    '&.size-md $wrapper': {
      width: '640px',
    },
    '&.size-lg $wrapper': {
      minWidth: '800px',
      maxWidth: '1080px',
    },
    '&.isModal': {
      backgroundColor: 'rgba(0,0,0,0.5)',
      '& $wrapper': {
        top: '50% !important',
        left: '50% !important',
        transform: 'translate(-50%, -50%) !important',
      },
    },
  },
  willDelete: {
    opacity: 0.6,
    '& .value-placeholder': {
      textDecoration: 'line-through',
    },
  },
})

class DropDownWrapper extends Component {
  state = {
    anchorEl: null,
  }

  handleClick = event => {
    const { handleOpen: propsHandleOpen } = this.props
    const handleOpen = () =>
      this.setState({
        anchorEl: event.currentTarget,
      })
    if (propsHandleOpen) {
      propsHandleOpen(event, { handleOpen })
    } else {
      handleOpen()
    }
  }

  handleClose = () => {
    const { handleClose: propsHandleClose } = this.props
    const handleClose = () =>
      this.setState({
        anchorEl: null,
      })

    if (propsHandleClose) {
      propsHandleClose(event, { handleClose })
    } else {
      handleClose()
    }
  }

  close = () => {
    this.setState({ anchorEl: null })
  }

  render() {
    const {
      actionButtonLabel,
      badgeVariant,
      children,
      classes,
      className,
      clearLabel,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      disabled,
      disableAdd,
      disableEnforceFocus,
      errorText,
      fullWidth,
      handleAction,
      handleCancel,
      handleClear,
      handleClose,
      heading,
      helperText,
      icon,
      iconComponent,
      id,
      inputClassName,
      isLabelInline,
      isModal,
      isRequired,
      isToolTip,
      justify,
      label,
      multipleFields,
      noMobile,
      noSpacing,
      notWrapper,
      noWrap,
      placeholder,
      showBadge,
      showClear,
      size,
      spacing,
      toolTipIcon,
      toolTipIconColor,
      toolTipIconSize,
      toolTipPosition,
      toolTipText,
      totalSelected,
      willDelete,
      withBorder,
      withDivider,
      value,
      variant,
    } = this.props
    const { anchorEl } = this.state
    const open = Boolean(anchorEl)

    function DisplayVariant(type, handleClick) {
      switch (type) {
        case 'button':
          return (
            <PrimaryButton
              aria-owns={open ? 'simple-popper' : null}
              aria-haspopup="true"
              className={cn({
                [classes.willDelete]: willDelete,
              })}
              onClick={!disabled && handleClick}
              aria-label={value || placeholder}
              style={customWidth && { width: `${customWidth}px` }}
              disabled={disabled}
            >
              {value || placeholder}
            </PrimaryButton>
          )
        case 'buttonSecondary':
          return (
            <SecondaryButton
              aria-owns={open ? 'simple-popper' : null}
              aria-haspopup="true"
              className={cn({
                [classes.willDelete]: willDelete,
              })}
              onClick={!disabled && handleClick}
              aria-label={value || placeholder}
              style={customWidth && { width: `${customWidth}px` }}
              disabled={disabled}
              variant="outlined"
            >
              {value || placeholder}
            </SecondaryButton>
          )
        case 'link':
          return (
            <TextOnlyButton
              aria-owns={open ? 'simple-popper' : null}
              aria-haspopup="true"
              className={cn({
                [classes.willDelete]: willDelete,
              })}
              onClick={!disabled && handleClick}
              label={value || placeholder}
              aria-label={value || placeholder}
              size="medium"
              style={customWidth && { width: `${customWidth}px` }}
              disabled={disabled}
            />
          )
        default:
          return (
            <span
              className={cn(classes.button, {
                [classes.willDelete]: willDelete,
              })}
              style={customWidth && { width: `${customWidth}px` }}
            >
              {/** biome-ignore lint/a11y/useFocusableInteractive: TODO */}
              {/** biome-ignore lint/a11y/useSemanticElements: TODO */}
              {/** biome-ignore lint/a11y/useKeyWithClickEvents: TODO */}
              <span
                aria-owns={open ? 'simple-popper' : null}
                aria-haspopup="true"
                className={cn({
                  [classes.placeholder]: placeholder,
                })}
                onClick={!disabled && handleClick}
                role="button"
                aria-label={value || placeholder}
              >
                {showBadge && (
                  <Badge
                    className={classes.badge}
                    value={totalSelected}
                    variant={!disabled ? badgeVariant : 'disabled'}
                  />
                )}
                <span className={cn(classes.valuePlace, !value && classes.placeholderLabel, 'value-placeholder')}>
                  {value || placeholder}
                </span>
              </span>
              <span className={classes.actions}>
                {showClear && (
                  // biome-ignore lint/a11y/useSemanticElements: TODO
                  // biome-ignore lint/a11y/useKeyWithClickEvents: TODO
                  // biome-ignore lint/a11y/useFocusableInteractive: TODO
                  <span
                    className={cn(classes.icon, classes.filterBtn)}
                    onClick={!disabled && handleClear}
                    role="button"
                    aria-label="Close"
                  >
                    <Close />
                  </span>
                )}
                {icon && (
                  // biome-ignore lint/a11y/useSemanticElements: TODO
                  // biome-ignore lint/a11y/useFocusableInteractive: TODO
                  // biome-ignore lint/a11y/useKeyWithClickEvents: TODO
                  <span className={classes.icon} onClick={!disabled && handleClick} role="button">
                    {iconComponent}
                  </span>
                )}
              </span>
            </span>
          )
      }
    }

    return (
      <LabelWrapper
        className={cn(classes.labelWrapper, className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        disabled={disabled}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        inputClassName={inputClassName}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        spacing={spacing}
        noSpacing={noSpacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        willDelete={willDelete}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        {DisplayVariant(variant, this.handleClick)}
        <Popover
          classes={{ paper: classes.wrapper }}
          className={cn(classes.modalWrapper, `size-${size}`, { isModal })}
          open={open}
          anchorEl={anchorEl}
          onClose={event =>
            handleClose(event, {
              handleClose: this.handleClose,
            })
          }
          disableEnforceFocus={disableEnforceFocus}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <header className={classes.header}>
            {heading && <H2>{heading}</H2>}
            <ButtonBase className={classes.close} onClick={this.handleClose} aria-label="Close">
              <Close />
            </ButtonBase>
          </header>
          <main className={classes.content}>
            {typeof children === 'function' ? children({ handleClose: this.handleClose }) : children}
          </main>
          <footer className={classes.footer}>
            {handleCancel && (
              <SecondaryButton
                onClick={event =>
                  handleCancel(event, {
                    handleClose: this.handleClose,
                  })
                }
                aria-label="Cancel"
                variant="outlined"
              >
                Cancel
              </SecondaryButton>
            )}
            {handleClear && (
              <SecondaryButton
                onClick={event =>
                  handleClear(event, {
                    handleClose: this.handleClose,
                  })
                }
                aria-label={clearLabel}
                variant="outlined"
              >
                {clearLabel}
              </SecondaryButton>
            )}
            {handleAction && (
              <PrimaryButton
                disabled={disableAdd || totalSelected <= 0}
                onClick={event =>
                  handleAction(event, {
                    handleClose: this.handleClose,
                  })
                }
                aria-label={actionButtonLabel}
              >
                {actionButtonLabel}
              </PrimaryButton>
            )}
          </footer>
        </Popover>
      </LabelWrapper>
    )
  }
}

DropDownWrapper.defaultProps = {
  actionButtonLabel: 'Save',
  badgeVariant: 'success',
  clearLabel: 'Clear',
  fullWidth: false,
  heading: 'Search',
  iconComponent: <ArrowDropDown />,
  isModal: false,
  notWrapper: true,
  placeholder: 'List',
  showBadge: false,
  showClear: false,
  size: 'auto',
  totalSelected: 0,
  variant: 'field',
}

const DropDownWrapperComponent = withStyles(styles)(DropDownWrapper)
DropDownWrapperComponent.displayName = 'DropDownWrapper'
export default DropDownWrapperComponent
